<template>
  <FormInput
    ref="field"
    :id="id"
    :inputTag="INPUT_TAGS.textarea"
    :value="value"
    :type="type"
    :label="label"
    :placeholder="placeholder"
    :isRequired="isRequired"
    :autocomplete="autocomplete"
    :variant="variant"
    :labelVariant="labelVariant"
    :labelStyle="labelStyle"
    :isCharacterCountActive="isCharacterCountActive"
    :maxCharacters="maxCharacters"
    :showIndicator="showIndicator"
    :showMessageOn="showMessageOn"
    :validations="validations"
    v-bind="$attrs"
    v-on="$listeners"
    @update:value="$emit('update:value', $event)"
  />
</template>

<script>
import formFieldInterfaceMixin from '@/components/_shared/Form/form-field-interface-mixin'
import propsInput, { INPUT_TAGS } from '@/components/_shared/Form/Input/props-input'
import FormInput from '@/components/_shared/Form/Input/FormInput.vue'

export default {
  name: 'FormTextArea',
  components: {
    FormInput,
  },
  mixins: [formFieldInterfaceMixin],

  props: { ...propsInput },

  data() {
    return {
      INPUT_TAGS,
    }
  },
}
</script>
